module.exports = __webpack_public_path__ + "static/media/new-banner-nick.4ea937cf.png";